import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import useSideNavAdminOptions, {
  SideNavItemsOption,
} from './useSideNavAdminOptions';

const useActiveAdminOption = (): SideNavItemsOption | undefined => {
  const location = useLocation();
  const adminOptions = useSideNavAdminOptions();
  return useMemo(
    () =>
      adminOptions.find((option: SideNavItemsOption) => {
        if (option.childrens) {
          const childrenOption = option.childrens.find(
            childOption => childOption.url === location.pathname
          );
          if (childrenOption) return option;
        }

        if (option.subPaths) {
          const subPathOption = option.subPaths.find(
            subPath => location.pathname.indexOf(subPath.url) !== -1
          );
          if (subPathOption) return true;
        }

        return (
          option.url === location.pathname ||
          location.pathname.startsWith(option.url)
        );
      }),
    [adminOptions, location.pathname]
  );
};

export default useActiveAdminOption;
